/** Clases de los botones de acción (mismo aspecto con `<Link>`, `<a>` o `<button>`). */
export const errorActionClass = {
  primary:
    'brutal brutal-press inline-flex items-center justify-center gap-2 rounded-xl bg-red px-6 py-3 font-display text-base font-bold text-white',
  secondary:
    'brutal brutal-press inline-flex items-center justify-center gap-2 rounded-xl bg-background px-6 py-3 font-display text-base font-bold text-foreground',
} as const
